import { useLocation } from "react-router-dom";
import base64 from "base-64";

const useQuery = () => new URLSearchParams(useLocation().search);

function openExternal(url: string, event: any = null) {
    if (event)
        event.preventDefault();
    window.open(url);
}

function getQueryStringRedirect() {
    let key = 'redirect';
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // eslint-disable-line
    let match = window.location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function decodeBase64(value: string,) {
    let base64String = value
    .replace(/-/g, '+')
    .replace(/_/g, '/');

    // Ajusta padding (=)
    while (base64String.length % 4 !== 0) {
        base64String += '=';
    }

    return base64.decode(base64String);
}

const HelperRoute = {
    useQuery,
    openExternal,
    getQueryStringRedirect,
    decodeBase64
}

export default HelperRoute;